
import React, {useState} from 'react'
type Props = {
  loadingText?:string
}


const Loader: React.FC<Props> = ({ loadingText }) => {

  return (
    <div className='d-flex h-100 text-white fs-5 flex-center flex-column bg-black-50'>
        <div className="loader mb-1 w-40px h-40px"></div>
        <span>{loadingText}</span>
    </div>
  )
}
export default Loader